/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptedTermsOfServiceItemViewModel } from '../models/AcceptedTermsOfServiceItemViewModel';
import type { AcceptedTermsOfServiceVersionViewModel } from '../models/AcceptedTermsOfServiceVersionViewModel';
import type { AcceptTermsOfServiceCommand } from '../models/AcceptTermsOfServiceCommand';
import type { BenefitViewModel } from '../models/BenefitViewModel';
import type { BusinessAccountBillingInfoViewModel } from '../models/BusinessAccountBillingInfoViewModel';
import type { BusinessAccountCustomerBillingPortalAccessViewModel } from '../models/BusinessAccountCustomerBillingPortalAccessViewModel';
import type { BusinessAccountGetMyselfQuery } from '../models/BusinessAccountGetMyselfQuery';
import type { BusinessAccountInsightsDataViewModel } from '../models/BusinessAccountInsightsDataViewModel';
import type { BusinessAccountInsightsViewModel } from '../models/BusinessAccountInsightsViewModel';
import type { BusinessAccountInvoiceListViewModel } from '../models/BusinessAccountInvoiceListViewModel';
import type { BusinessAccountInvoicePaymentLinkViewModel } from '../models/BusinessAccountInvoicePaymentLinkViewModel';
import type { BusinessAccountLoginViewModel } from '../models/BusinessAccountLoginViewModel';
import type { BusinessAccountPaymentMethodFormViewModel } from '../models/BusinessAccountPaymentMethodFormViewModel';
import type { BusinessAccountTransactionListViewModel } from '../models/BusinessAccountTransactionListViewModel';
import type { BusinessAccountViewModel } from '../models/BusinessAccountViewModel';
import type { BusinessViewModel } from '../models/BusinessViewModel';
import type { CheckDashboardInvitationStatusByEmailQuery } from '../models/CheckDashboardInvitationStatusByEmailQuery';
import type { CommandSuccessViewModel } from '../models/CommandSuccessViewModel';
import type { CommandSuccessWithIdViewModel } from '../models/CommandSuccessWithIdViewModel';
import type { CompanyTermsOfServiceViewModel } from '../models/CompanyTermsOfServiceViewModel';
import type { CompanyViewModel } from '../models/CompanyViewModel';
import type { ConversionFunnelViewModel } from '../models/ConversionFunnelViewModel';
import type { CreateOrUpdateBenefitCommand } from '../models/CreateOrUpdateBenefitCommand';
import type { CreateOrUpdateBusinessCommand } from '../models/CreateOrUpdateBusinessCommand';
import type { CreateOrUpdateCustomLinksCommand } from '../models/CreateOrUpdateCustomLinksCommand';
import type { CreateOrUpdateExternalLinksCommand } from '../models/CreateOrUpdateExternalLinksCommand';
import type { CustomersCountByMonthViewModel } from '../models/CustomersCountByMonthViewModel';
import type { DailyAppInstallsStatsForAdmin } from '../models/DailyAppInstallsStatsForAdmin';
import type { DailyAverageEngagementTimeStatsForAdmin } from '../models/DailyAverageEngagementTimeStatsForAdmin';
import type { DashboardInvitationStatusViewModel } from '../models/DashboardInvitationStatusViewModel';
import type { ExternalLinkCustomViewModel } from '../models/ExternalLinkCustomViewModel';
import type { ExternalLinksViewModel } from '../models/ExternalLinksViewModel';
import type { GetAcceptedTermsOfServiceByCompanyQuery } from '../models/GetAcceptedTermsOfServiceByCompanyQuery';
import type { GetAllAcceptedTermsOfServiceQuery } from '../models/GetAllAcceptedTermsOfServiceQuery';
import type { GetBenefitQuery } from '../models/GetBenefitQuery';
import type { GetBusinessDetailsQuery } from '../models/GetBusinessDetailsQuery';
import type { GetCompanyBillingInfoQuery } from '../models/GetCompanyBillingInfoQuery';
import type { GetCompanyCustomerBillingPortalAccessQuery } from '../models/GetCompanyCustomerBillingPortalAccessQuery';
import type { GetCompanyCustomersCountByMonthForAdminQuery } from '../models/GetCompanyCustomersCountByMonthForAdminQuery';
import type { GetCompanyForAdminQuery } from '../models/GetCompanyForAdminQuery';
import type { GetCompanyInsightsForAdminQuery } from '../models/GetCompanyInsightsForAdminQuery';
import type { GetCompanyInsightsQuery } from '../models/GetCompanyInsightsQuery';
import type { GetCompanyInvoiceListQuery } from '../models/GetCompanyInvoiceListQuery';
import type { GetCompanyPaymentMethodFormQuery } from '../models/GetCompanyPaymentMethodFormQuery';
import type { GetCompanyQuery } from '../models/GetCompanyQuery';
import type { GetDailyAppInstallsStatsForAdminQuery } from '../models/GetDailyAppInstallsStatsForAdminQuery';
import type { GetDailyAverageEngagementTimeStatsForAdminQuery } from '../models/GetDailyAverageEngagementTimeStatsForAdminQuery';
import type { GetExternalLinksCustomQuery } from '../models/GetExternalLinksCustomQuery';
import type { GetExternalLinksQuery } from '../models/GetExternalLinksQuery';
import type { GetImageAssetQuery } from '../models/GetImageAssetQuery';
import type { GetInvoicePaymentLinkQuery } from '../models/GetInvoicePaymentLinkQuery';
import type { GetKpiReportQuery } from '../models/GetKpiReportQuery';
import type { GetLatestTermsOfServiceQuery } from '../models/GetLatestTermsOfServiceQuery';
import type { GetLifetimeAppInstallsStatsForAdminQuery } from '../models/GetLifetimeAppInstallsStatsForAdminQuery';
import type { GetLifetimeAverageEngagementTimeStatsForAdminQuery } from '../models/GetLifetimeAverageEngagementTimeStatsForAdminQuery';
import type { GetMonthlyAppInstallsStatsForAdminQuery } from '../models/GetMonthlyAppInstallsStatsForAdminQuery';
import type { GetMonthlyAverageEngagementTimeStatsForAdminQuery } from '../models/GetMonthlyAverageEngagementTimeStatsForAdminQuery';
import type { GetNewsletterCommunicationStatisticForAdminQuery } from '../models/GetNewsletterCommunicationStatisticForAdminQuery';
import type { GetOisterBonusPointOverviewQuery } from '../models/GetOisterBonusPointOverviewQuery';
import type { GetPartnerNetworkReportQuery } from '../models/GetPartnerNetworkReportQuery';
import type { GetPublicTermsOfServiceQuery } from '../models/GetPublicTermsOfServiceQuery';
import type { GetTermsOfServiceQuery } from '../models/GetTermsOfServiceQuery';
import type { GetUsersCountByMonthForAdminQuery } from '../models/GetUsersCountByMonthForAdminQuery';
import type { ImageViewModel } from '../models/ImageViewModel';
import type { InviteToCompanyDashboardByEmailCommand } from '../models/InviteToCompanyDashboardByEmailCommand';
import type { KpiReportViewModel } from '../models/KpiReportViewModel';
import type { LifetimeAppInstallsStatsForAdmin } from '../models/LifetimeAppInstallsStatsForAdmin';
import type { LifetimeAverageEngagementTimeStatsForAdmin } from '../models/LifetimeAverageEngagementTimeStatsForAdmin';
import type { ListBenefitQuery } from '../models/ListBenefitQuery';
import type { ListBusinessForAdminQuery } from '../models/ListBusinessForAdminQuery';
import type { ListBusinessQuery } from '../models/ListBusinessQuery';
import type { ListCompaniesForAdminQuery } from '../models/ListCompaniesForAdminQuery';
import type { ListCompanyTransactionsForAdminQuery } from '../models/ListCompanyTransactionsForAdminQuery';
import type { ListCompanyTransactionsQuery } from '../models/ListCompanyTransactionsQuery';
import type { ListConversionFunnelQuery } from '../models/ListConversionFunnelQuery';
import type { ListCustomLinksQuery } from '../models/ListCustomLinksQuery';
import type { ListExternalLinksQuery } from '../models/ListExternalLinksQuery';
import type { ListSearchToClickLogQuery } from '../models/ListSearchToClickLogQuery';
import type { ListTopClickedBusinessesQuery } from '../models/ListTopClickedBusinessesQuery';
import type { ListTopCustomersBracketsQuery } from '../models/ListTopCustomersBracketsQuery';
import type { ListTopCustomersQuery } from '../models/ListTopCustomersQuery';
import type { ListTopMerchantsQuery } from '../models/ListTopMerchantsQuery';
import type { ListTopSearchesQuery } from '../models/ListTopSearchesQuery';
import type { ListZeroResultSearchesQuery } from '../models/ListZeroResultSearchesQuery';
import type { LoginBusinessAccountCommand } from '../models/LoginBusinessAccountCommand';
import type { LoginBusinessAccountOnBehalfOfCompanyCommand } from '../models/LoginBusinessAccountOnBehalfOfCompanyCommand';
import type { LogoutFromBehalfOfCompanyCommand } from '../models/LogoutFromBehalfOfCompanyCommand';
import type { MonthlyAppInstallsStatsForAdmin } from '../models/MonthlyAppInstallsStatsForAdmin';
import type { MonthlyAverageEngagementTimeStatsForAdmin } from '../models/MonthlyAverageEngagementTimeStatsForAdmin';
import type { NewsletterCommunicationStatisticViewModel } from '../models/NewsletterCommunicationStatisticViewModel';
import type { OisterBonusPointOverviewViewModel } from '../models/OisterBonusPointOverviewViewModel';
import type { PartnerNetworkReportViewModel } from '../models/PartnerNetworkReportViewModel';
import type { RequestPasswordResetCommand } from '../models/RequestPasswordResetCommand';
import type { ResetPasswordCommand } from '../models/ResetPasswordCommand';
import type { SearchToClickLogListViewModel } from '../models/SearchToClickLogListViewModel';
import type { TermsOfServiceViewModel } from '../models/TermsOfServiceViewModel';
import type { TopClickedBusinessListViewModel } from '../models/TopClickedBusinessListViewModel';
import type { TopCustomerBracketsListViewModel } from '../models/TopCustomerBracketsListViewModel';
import type { TopCustomerListViewModel } from '../models/TopCustomerListViewModel';
import type { TopMerchantListViewModel } from '../models/TopMerchantListViewModel';
import type { TopSearchListViewModel } from '../models/TopSearchListViewModel';
import type { UpdateCompanyCommand } from '../models/UpdateCompanyCommand';
import type { UsersCountByMonthViewModel } from '../models/UsersCountByMonthViewModel';
import type { ZeroResultSearchListViewModel } from '../models/ZeroResultSearchListViewModel';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BusinessAccountService {
    /**
     * Login business account
     * @param requestBody
     * @returns BusinessAccountLoginViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountLogin(
        requestBody?: LoginBusinessAccountCommand,
    ): CancelablePromise<BusinessAccountLoginViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/login',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Login on behalf of company (admin only)
     * @param requestBody
     * @returns BusinessAccountLoginViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountLoginOnBehalfOfCompany(
        requestBody?: LoginBusinessAccountOnBehalfOfCompanyCommand,
    ): CancelablePromise<BusinessAccountLoginViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/login-on-behalf-of-company',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Logout from on behalf of company (admin only)
     * @param requestBody
     * @returns BusinessAccountLoginViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountLogoutFromBehalfOfCompany(
        requestBody?: LogoutFromBehalfOfCompanyCommand,
    ): CancelablePromise<BusinessAccountLoginViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/logout-from-behalf-of-company',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Logout business account
     * @returns any Success
     * @throws ApiError
     */
    public static postApiBusinessAccountLogout(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/logout',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get account details
     * @param requestBody
     * @returns BusinessAccountViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetMyself(
        requestBody?: BusinessAccountGetMyselfQuery,
    ): CancelablePromise<BusinessAccountViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-myself',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Refresh access token
     * @returns any Success
     * @throws ApiError
     */
    public static postApiBusinessAccountRefreshAccessToken(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/refresh-access-token',
        });
    }
    /**
     * Request password reset
     * @param requestBody
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountRequestPasswordReset(
        requestBody?: RequestPasswordResetCommand,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/request-password-reset',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Reset password
     * @param requestBody
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountResetPassword(
        requestBody?: ResetPasswordCommand,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/reset-password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Upload image
     * @param title
     * @param formData
     * @returns CommandSuccessWithIdViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountUploadImage(
        title?: string,
        formData?: {
            File?: Blob;
        },
    ): CancelablePromise<CommandSuccessWithIdViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/upload-image',
            query: {
                'Title': title,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get image
     * @param requestBody
     * @returns ImageViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetImage(
        requestBody?: GetImageAssetQuery,
    ): CancelablePromise<ImageViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-image',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Update company
     * @param requestBody
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountUpdateCompany(
        requestBody?: UpdateCompanyCommand,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/update-company',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Create or update benefit
     * @param requestBody
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountCreateOrUpdateBenefit(
        requestBody?: CreateOrUpdateBenefitCommand,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/create-or-update-benefit',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Create or update business
     * @param requestBody
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountCreateOrUpdateBusiness(
        requestBody?: CreateOrUpdateBusinessCommand,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/create-or-update-business',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Create or update external links
     * @param requestBody
     * @returns CommandSuccessWithIdViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountCreateOrUpdateExternalLinks(
        requestBody?: CreateOrUpdateExternalLinksCommand,
    ): CancelablePromise<CommandSuccessWithIdViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/create-or-update-external-links',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Create or update custom links
     * @param requestBody
     * @returns CommandSuccessWithIdViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountCreateOrUpdateCustomLinks(
        requestBody?: CreateOrUpdateCustomLinksCommand,
    ): CancelablePromise<CommandSuccessWithIdViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/create-or-update-custom-links',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get company
     * @param requestBody
     * @returns CompanyViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetCompany(
        requestBody?: GetCompanyQuery,
    ): CancelablePromise<CompanyViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-company',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get business
     * @param requestBody
     * @returns BusinessViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetBusiness(
        requestBody?: GetBusinessDetailsQuery,
    ): CancelablePromise<BusinessViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-business',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get benefit
     * @param requestBody
     * @returns BenefitViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetBenefit(
        requestBody?: GetBenefitQuery,
    ): CancelablePromise<BenefitViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-benefit',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get external links
     * @param requestBody
     * @returns ExternalLinksViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetExternalLinks(
        requestBody?: GetExternalLinksQuery,
    ): CancelablePromise<ExternalLinksViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-external-links',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get external links custom
     * @param requestBody
     * @returns ExternalLinkCustomViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetExternalLinksCustom(
        requestBody?: GetExternalLinksCustomQuery,
    ): CancelablePromise<ExternalLinkCustomViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-external-links-custom',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List benefits
     * @param requestBody
     * @returns BenefitViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountListBenefits(
        requestBody?: ListBenefitQuery,
    ): CancelablePromise<Array<BenefitViewModel>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/list-benefits',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List businesses
     * @param requestBody
     * @returns BusinessViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountListBusinesses(
        requestBody?: ListBusinessQuery,
    ): CancelablePromise<Array<BusinessViewModel>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/list-businesses',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List businesses for admin
     * @param requestBody
     * @returns BusinessViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountListBusinessesForAdmin(
        requestBody?: ListBusinessForAdminQuery,
    ): CancelablePromise<Array<BusinessViewModel>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/list-businesses-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List external links
     * @param requestBody
     * @returns ExternalLinksViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountListExternalLinks(
        requestBody?: ListExternalLinksQuery,
    ): CancelablePromise<Array<ExternalLinksViewModel>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/list-external-links',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List custom links
     * @param requestBody
     * @returns ExternalLinkCustomViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountListCustomLinks(
        requestBody?: ListCustomLinksQuery,
    ): CancelablePromise<Array<ExternalLinkCustomViewModel>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/list-custom-links',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List transactions
     * @param requestBody
     * @returns BusinessAccountTransactionListViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountListTransactions(
        requestBody?: ListCompanyTransactionsQuery,
    ): CancelablePromise<BusinessAccountTransactionListViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/list-transactions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List transactions
     * @param requestBody
     * @returns BusinessAccountTransactionListViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountListTransactionsForAdmin(
        requestBody?: ListCompanyTransactionsForAdminQuery,
    ): CancelablePromise<BusinessAccountTransactionListViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/list-transactions-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List top merchants for admin
     * @param requestBody
     * @returns TopMerchantListViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountListTopMerchantsForAdmin(
        requestBody?: ListTopMerchantsQuery,
    ): CancelablePromise<TopMerchantListViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/list-top-merchants-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List top customers for admin
     * @param requestBody
     * @returns TopCustomerListViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountListTopCustomersForAdmin(
        requestBody?: ListTopCustomersQuery,
    ): CancelablePromise<TopCustomerListViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/list-top-customers-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List top customers brackets for admin
     * @param requestBody
     * @returns TopCustomerBracketsListViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountListTopCustomersBracketsForAdmin(
        requestBody?: ListTopCustomersBracketsQuery,
    ): CancelablePromise<TopCustomerBracketsListViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/list-top-customers-brackets-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * OiSTER bonus point overview for admin
     * @param requestBody
     * @returns OisterBonusPointOverviewViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetOisterBonusPointOverviewForAdmin(
        requestBody?: GetOisterBonusPointOverviewQuery,
    ): CancelablePromise<OisterBonusPointOverviewViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-oister-bonus-point-overview-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List top searches for admin
     * @param requestBody
     * @returns TopSearchListViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountListTopSearchesForAdmin(
        requestBody?: ListTopSearchesQuery,
    ): CancelablePromise<TopSearchListViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/list-top-searches-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List zero-result searches for admin (from Typesense nohits_queries aggregations).
     * @param requestBody
     * @returns ZeroResultSearchListViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountListZeroResultSearchesForAdmin(
        requestBody?: ListZeroResultSearchesQuery,
    ): CancelablePromise<ZeroResultSearchListViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/list-zero-result-searches-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List top businesses by click_count for admin (from Typesense counter aggregation).
     * @param requestBody
     * @returns TopClickedBusinessListViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountListTopClickedBusinessesForAdmin(
        requestBody?: ListTopClickedBusinessesQuery,
    ): CancelablePromise<TopClickedBusinessListViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/list-top-clicked-businesses-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List raw search-to-click events for admin (from Typesense clickstream log).
     * @param requestBody
     * @returns SearchToClickLogListViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountListSearchToClickLogForAdmin(
        requestBody?: ListSearchToClickLogQuery,
    ): CancelablePromise<SearchToClickLogListViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/list-search-to-click-log-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get conversion funnel for admin (joins Typesense clicks with DB transactions within attribution window).
     * @param requestBody
     * @returns ConversionFunnelViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountListConversionFunnelForAdmin(
        requestBody?: ListConversionFunnelQuery,
    ): CancelablePromise<ConversionFunnelViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/list-conversion-funnel-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List companies for admin
     * @param requestBody
     * @returns CompanyViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountListCompaniesForAdmin(
        requestBody?: ListCompaniesForAdminQuery,
    ): CancelablePromise<Array<CompanyViewModel>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/list-companies-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get company for admin
     * @param requestBody
     * @returns CompanyViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetCompanyForAdmin(
        requestBody?: GetCompanyForAdminQuery,
    ): CancelablePromise<CompanyViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-company-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get insights
     * @param requestBody
     * @returns BusinessAccountInsightsViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetInsights(
        requestBody?: GetCompanyInsightsQuery,
    ): CancelablePromise<BusinessAccountInsightsViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-insights',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get insights for admin
     * @param requestBody
     * @returns BusinessAccountInsightsDataViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetInsightsForAdmin(
        requestBody?: GetCompanyInsightsForAdminQuery,
    ): CancelablePromise<BusinessAccountInsightsDataViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-insights-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get newsletter communication statistic for admin
     * @param requestBody
     * @returns NewsletterCommunicationStatisticViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetNewsletterCommunicationStatisticForAdmin(
        requestBody?: GetNewsletterCommunicationStatisticForAdminQuery,
    ): CancelablePromise<NewsletterCommunicationStatisticViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-newsletter-communication-statistic-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get billing info
     * @param requestBody
     * @returns BusinessAccountBillingInfoViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetBillingInfo(
        requestBody?: GetCompanyBillingInfoQuery,
    ): CancelablePromise<BusinessAccountBillingInfoViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-billing-info',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List invoices
     * @param requestBody
     * @returns BusinessAccountInvoiceListViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountListInvoices(
        requestBody?: GetCompanyInvoiceListQuery,
    ): CancelablePromise<BusinessAccountInvoiceListViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/list-invoices',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get Billwerk customer portal access
     * @param requestBody
     * @returns BusinessAccountCustomerBillingPortalAccessViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetCustomerBillingPortalAccess(
        requestBody?: GetCompanyCustomerBillingPortalAccessQuery,
    ): CancelablePromise<BusinessAccountCustomerBillingPortalAccessViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-customer-billing-portal-access',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get Billwerk payment method form
     * @param requestBody
     * @returns BusinessAccountPaymentMethodFormViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetPaymentMethodForm(
        requestBody?: GetCompanyPaymentMethodFormQuery,
    ): CancelablePromise<BusinessAccountPaymentMethodFormViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-payment-method-form',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get payment link for an invoice
     * @param requestBody
     * @returns BusinessAccountInvoicePaymentLinkViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetInvoicePaymentLink(
        requestBody?: GetInvoicePaymentLinkQuery,
    ): CancelablePromise<BusinessAccountInvoicePaymentLinkViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-invoice-payment-link',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiBusinessAccountInviteToDashboardByEmail(
        requestBody?: InviteToCompanyDashboardByEmailCommand,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/invite-to-dashboard-by-email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `Conflict`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns DashboardInvitationStatusViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountCheckDashboardInvitationStatusByEmail(
        requestBody?: CheckDashboardInvitationStatusByEmailQuery,
    ): CancelablePromise<DashboardInvitationStatusViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/check-dashboard-invitation-status-by-email',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns CompanyTermsOfServiceViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetTermsOfService(
        requestBody?: GetTermsOfServiceQuery,
    ): CancelablePromise<CompanyTermsOfServiceViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-terms-of-service',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Latest published business terms for the public /forretningsbetingelser page
     * (terms text only — no acceptance data).
     * @param requestBody
     * @returns TermsOfServiceViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetPublicTermsOfService(
        requestBody?: GetPublicTermsOfServiceQuery,
    ): CancelablePromise<TermsOfServiceViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-public-terms-of-service',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiBusinessAccountAcceptTermsOfService(
        requestBody?: AcceptTermsOfServiceCommand,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/accept-terms-of-service',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get all accepted terms of service for admin
     * @param requestBody
     * @returns AcceptedTermsOfServiceItemViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetAllAcceptedTermsOfService(
        requestBody?: GetAllAcceptedTermsOfServiceQuery,
    ): CancelablePromise<Array<AcceptedTermsOfServiceItemViewModel>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-all-accepted-terms-of-service',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get latest terms of service for admin
     * @param requestBody
     * @returns TermsOfServiceViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetLatestTermsOfService(
        requestBody?: GetLatestTermsOfServiceQuery,
    ): CancelablePromise<TermsOfServiceViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-latest-terms-of-service',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get all accepted terms of service versions by company for admin
     * @param requestBody
     * @returns AcceptedTermsOfServiceVersionViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetAcceptedTermsOfServiceByCompany(
        requestBody?: GetAcceptedTermsOfServiceByCompanyQuery,
    ): CancelablePromise<Array<AcceptedTermsOfServiceVersionViewModel>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-accepted-terms-of-service-by-company',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get daily installs stats for admin
     * @param requestBody
     * @returns DailyAppInstallsStatsForAdmin Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetDailyAppInstallsStatsForAdmin(
        requestBody?: GetDailyAppInstallsStatsForAdminQuery,
    ): CancelablePromise<DailyAppInstallsStatsForAdmin> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-daily-app-installs-stats-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get monthly installs stats for admin
     * @param requestBody
     * @returns MonthlyAppInstallsStatsForAdmin Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetMonthlyAppInstallsStatsForAdmin(
        requestBody?: GetMonthlyAppInstallsStatsForAdminQuery,
    ): CancelablePromise<MonthlyAppInstallsStatsForAdmin> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-monthly-app-installs-stats-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get lifetime installs stats for admin
     * @param requestBody
     * @returns LifetimeAppInstallsStatsForAdmin Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetLifetimeAppInstallsStatsForAdmin(
        requestBody?: GetLifetimeAppInstallsStatsForAdminQuery,
    ): CancelablePromise<LifetimeAppInstallsStatsForAdmin> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-lifetime-app-installs-stats-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get daily average engagement time stats for admin
     * @param requestBody
     * @returns DailyAverageEngagementTimeStatsForAdmin Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetDailyAverageEngagementTimeStatsForAdmin(
        requestBody?: GetDailyAverageEngagementTimeStatsForAdminQuery,
    ): CancelablePromise<DailyAverageEngagementTimeStatsForAdmin> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-daily-average-engagement-time-stats-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get monthly average engagement time stats for admin
     * @param requestBody
     * @returns MonthlyAverageEngagementTimeStatsForAdmin Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetMonthlyAverageEngagementTimeStatsForAdmin(
        requestBody?: GetMonthlyAverageEngagementTimeStatsForAdminQuery,
    ): CancelablePromise<MonthlyAverageEngagementTimeStatsForAdmin> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-monthly-average-engagement-time-stats-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get lifetime average engagement time stats for admin
     * @param requestBody
     * @returns LifetimeAverageEngagementTimeStatsForAdmin Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetLifetimeAverageEngagementTimeStatsForAdmin(
        requestBody?: GetLifetimeAverageEngagementTimeStatsForAdminQuery,
    ): CancelablePromise<LifetimeAverageEngagementTimeStatsForAdmin> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-lifetime-average-engagement-time-stats-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get users count by month for admin
     * @param requestBody
     * @returns UsersCountByMonthViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetUsersCountByMonthForAdmin(
        requestBody?: GetUsersCountByMonthForAdminQuery,
    ): CancelablePromise<Array<UsersCountByMonthViewModel>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-users-count-by-month-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get company customers count by month for admin
     * @param requestBody
     * @returns CustomersCountByMonthViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetCompanyCustomersCountByMonthForAdmin(
        requestBody?: GetCompanyCustomersCountByMonthForAdminQuery,
    ): CancelablePromise<Array<CustomersCountByMonthViewModel>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-company-customers-count-by-month-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get KPI report for admin
     * @param requestBody
     * @returns KpiReportViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetKpiReport(
        requestBody?: GetKpiReportQuery,
    ): CancelablePromise<KpiReportViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-kpi-report',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Partner Network Report (admin only)
     * @param requestBody
     * @returns PartnerNetworkReportViewModel Success
     * @throws ApiError
     */
    public static postApiBusinessAccountGetPartnerNetworkReport(
        requestBody?: GetPartnerNetworkReportQuery,
    ): CancelablePromise<PartnerNetworkReportViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-account/get-partner-network-report',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
}
